import { autoinject } from 'aurelia-dependency-injection';
import { BankTotal, CustomerTotalValuesReportViewModel, InstrumentValueGroup, InstrumentValuesReportViewModel, PortfolioReportClient } from '../clients/reporting-clients';
import { CacheService } from './cache-service';

@autoinject
export class PortfolioReportCache {
  constructor(private portfolioReportClient: PortfolioReportClient, private cacheService: CacheService) { }

  async instrumentValueGroupsOverTime(companyIdentityId: number, categoryTypeId: number | null | undefined, fromDate: string | undefined, toDate: string, ignoreCachedDataExpiry: boolean): Promise<InstrumentValueGroup[]> {
    return (await this.cacheService.getOrSet(`instrumentValueGroupsOverTime-${companyIdentityId}-${categoryTypeId}-${fromDate}-${toDate}`,
      () => this.portfolioReportClient.instrumentValueGroupsOverTime([companyIdentityId], categoryTypeId, fromDate, toDate),
      60000, ignoreCachedDataExpiry)).map(x => new InstrumentValueGroup(x));
  }

  async bankTotalsOverTime(companyIdentityId: number, fromDate: string | undefined, toDate: string, ignoreCachedDataExpiry: boolean): Promise<BankTotal[]> {
    return (await this.cacheService.getOrSet(`bankTotalsOverTime-${companyIdentityId}-${fromDate}-${toDate}`,
      () => this.portfolioReportClient.bankTotalsOverTime(companyIdentityId, fromDate, toDate),
      60000, ignoreCachedDataExpiry)).map(x => new BankTotal(x));
  }

  async instrumentValues(companyIdentityId: number, fromDate: string | null | undefined, toDate: string, categoryTypeId: number | null | undefined, portfolio: string, ignoreCachedDataExpiry: boolean): Promise<InstrumentValuesReportViewModel[]> {
    return (await this.cacheService.getOrSet(`instrumentValues-${companyIdentityId}-${fromDate}-${toDate}-${categoryTypeId}-${portfolio}`,
      () => this.portfolioReportClient.instrumentValues(companyIdentityId, fromDate, toDate, categoryTypeId, portfolio, 0),
      60000, ignoreCachedDataExpiry)).map(x => new InstrumentValuesReportViewModel(x));
  }

  async customerTotals(companyIdentityId: number, fromDate: string | null | undefined, toDate: string, indexAi: string | null | undefined, ignoreCachedDataExpiry: boolean, historicalMonths: number | undefined = 12): Promise<CustomerTotalValuesReportViewModel[]> {
    return (await this.cacheService.getOrSet(`customerTotals-${companyIdentityId}-${fromDate}-${toDate}-${indexAi}-${historicalMonths}`,
      () => this.portfolioReportClient.customerTotals(companyIdentityId, fromDate, toDate, indexAi, historicalMonths),
      60000, ignoreCachedDataExpiry)).map(x => new CustomerTotalValuesReportViewModel(x));
  }
}
